import React, { FC } from "react";
import laptopAlertSign from "@/assets/studentTile/laptop-alert-sign.svg?url";
import { Button, Image, Flex, Text } from "@chakra-ui/react";
import { useClassroomLayoutStore } from "@/stores/v2/classroomLayoutStore";
import InactiveTileContentLayout from "@/js/components/StudentTile/components/inactiveScreenStates/InactiveTileContentLayout";

interface CannotDisplayScreenProps {
	useIssueOngoing: () => void;
}

const CannotDisplayScreen: FC<CannotDisplayScreenProps> = (props: CannotDisplayScreenProps) => {
	const tileSize = useClassroomLayoutStore((state) => state.tileSize);

	return (
		<Flex flexDirection={"column"} align={"center"} height={tileSize !== "sm" ? "100%" : ""}>
			{tileSize !== "sm" && <Image src={laptopAlertSign} htmlHeight={42} htmlWidth={42} />}
			<InactiveTileContentLayout>
				<Text fontWeight={"bold"}>Cannot display screen</Text>
				<Text>Please try restarting their device. {tileSize === "lg" && "If this hasn’t worked let us know."}</Text>
			</InactiveTileContentLayout>
			<Button size={"sm"} py={0} px={4} mb={tileSize === "lg" ? 4 : 0} mt={"auto"} onClick={() => props.useIssueOngoing()}>
				Still having trouble
			</Button>
		</Flex>
	);
};

export default CannotDisplayScreen;
